module.exports = __webpack_public_path__ + "img/values-wheel.ac1e010d.png";